module.exports = __webpack_public_path__ + "static/lights40-aea57c94c93cfd9126b82a9c8ad48408.jpg";